/* eslint-disable no-underscore-dangle */
((ns) => {
  const { logError } = ns;

  // Get tax rate from settings or algoliaConfig
  const TAX_RATE = 1 + (window.algoliaConfig?.taxRate || (window.settings?.mwst_value || 19) / 100);

  // Initialize badges map and energy labels from energy label data
  let BADGES_MAP = {};
  let ENERGY_LABELS_MAP = {};
 // Store hit data for click handling
 const hitDataStore = new Map();

 // Helper function to get customer data
 const getCustomerData = () => {
   const existingDataLayer = window.dataLayer || [];
   for (let i = 0; i < existingDataLayer.length; i++) {
     if (existingDataLayer[i].user_data) {
       return existingDataLayer[i].user_data;
     }
   }
   return {
     first_name: null,
     last_name: null,
     email: null,
     phone: null,
     city: null,
     country: null,
     zip: null,
     region: null,
     street: null,
     customer_id: null
   };
 };

 // Helper function to handle product clicks
 const handleProductClick = (productHandle, e) => {
   if (e.target.closest("global-fancy-box") || 
       e.target.closest(".product-card__energy-label--vertical-card") ||
       e.target.closest(".product-card__atc") ||
       e.target.closest(".wishlist")) {
     return;
   }

   const hit = hitDataStore.get(productHandle);
   if (!hit) return;

   e.preventDefault();
   e.stopPropagation();

   // Parse categories
   let categories = [];
   try {
     if (hit.meta?.custom?.item_categories) {
       let categoriesData = hit.meta.custom.item_categories;
       if (typeof categoriesData === 'string') {
         try {
           categoriesData = JSON.parse(categoriesData);
         } catch (e) {
           console.error('Failed to parse categories JSON:', e);
         }
       }
       if (Array.isArray(categoriesData) && categoriesData.length === 1 && typeof categoriesData[0] === 'string') {
         categories = categoriesData[0].split('/').map(cat => cat.trim());
       } else if (typeof categoriesData === 'string' && categoriesData.includes('/')) {
         categories = categoriesData.split('/').map(cat => cat.trim());
       } else if (Array.isArray(categoriesData)) {
         categories = categoriesData;
       }
       categories = categories.map(cat => {
         if (typeof cat === 'string') {
           return cat.replace(/[\[\]"\\]/g, '').trim();
         }
         return cat;
       });
     }
   } catch (error) {
     console.error('Error parsing categories:', error);
     categories = [];
   }

   // Construct ecommerce object
   const ecommerce = {
     items: [{
       item_id: hit.objectID,
       item_sku: hit.sku || "",
       item_variant: hit.objectID,
       item_name: hit.title,
       variant_name: hit.title,
       item_category: categories[0] || "",
       item_category2: categories[1] || "",
       item_category3: categories[2] || "",
       price: hit.price * TAX_RATE,
       item_brand: hit.vendor,
       quantity: "1"
     }]
   };

   // Prepare select_item_dev data
   const temp_select_dev = {
     customer_type_g: window.selectedCustomerType === 'private' ? 'B2C' : 'B2B',
     country_language_g: window.DOMAIN_MAP?.[window.location.hostname] || null,
     login_status_g: window.customer ? true : false,
     uuid_g: window.customer?.id || null,
     checkout_type: window.customer ? "registered" : "guest",
     newsletter_status: window.customer?.accepts_marketing ? 'subscribed' : 'not_subscribed',
     items: [{
       item_id: ecommerce.items[0].item_id,
       item_category: ecommerce.items[0].item_category,
       item_category2: ecommerce.items[0].item_category2,
       item_category3: ecommerce.items[0].item_category3
     }]
   };

   // Push to dataLayer
   window.dataLayer.push(temp_select_dev);
   window.dataLayer.push({
     event: 'select_item_dev',
     user_data: getCustomerData(),
     ecommerce,
     ecomm_pagetype: window.template?.name || ""
   });

   // Navigate to product page
   window.location.href = `/products/${hit.handle}${hit.__queryID ? `?queryID=${hit.__queryID}` : ""}`;
 };
  const initializeBadgesMap = () => {
    try {
      const energyLabelData = document.getElementById("energy-label-data");
      if (energyLabelData) {
        const data = JSON.parse(energyLabelData.textContent);
        BADGES_MAP = data.badges || {};
        ENERGY_LABELS_MAP = data.energy_labels || {};
      }
    } catch (error) {
      logError(error, "Failed to initialize badges map");
      BADGES_MAP = {};
      ENERGY_LABELS_MAP = {};
    }
  };

  // Initialize on load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeBadgesMap);
  } else {
    initializeBadgesMap();
  }

  // Helper function to format price to German currency format
  const formatPrice = (price) =>
    new Intl.NumberFormat("de-DE", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);

  // Helper function to determine availability status
  const getAvailabilityStatus = (hit) => {
    const isExpress = hit.meta?.custom?.express_tag === 1;
    const isAvailable = hit.inventory_available !== false;

    if (!isAvailable) {
      return {
        text: window.searchTranslations?.product?.availability?.unavailable || "Nicht verfügbar",
        className: "product__availability--unavailable",
        style: "color: var(--color--text-secondary, #6c757d);",
      };
    }
    if (isExpress) {
      return {
        text: window.searchTranslations?.product?.availability?.express || "Sofort lieferbar",
        className: "product__availability--standard",
        style: "color: var(--color--success, #28a745);",
      };
    }
    return {
      text: window.searchTranslations?.product?.availability?.standard || "Lieferbar",
      className: "product__availability--standard",
      style: "",
    };
  };

  // Helper function to get energy label data for a product
  const getEnergyLabelData = (hit) => {
    try {
      const energyMetafield = hit.meta?.custom?.energy;
      const energyLabel = hit.meta?.custom?.weitere_informationen?.Energieeffizienzklasse;

      if ((!energyMetafield && !energyLabel) || !ENERGY_LABELS_MAP) {
        return null;
      }

      // Find the energy label data by ID
      let energyLabelId;
      try {
        energyLabelId = energyMetafield.split("/").pop();
      } catch (error) {
        energyLabelId = null;
      }

      // Try to find by ID first, then by label match
      let energyData = null;
      if (energyLabelId && ENERGY_LABELS_MAP) {
        try {
          energyData = ENERGY_LABELS_MAP[energyLabelId];
        } catch (error) {
          energyData = null;
        }
      }

      if (!energyData) {
        energyData = Object.values(ENERGY_LABELS_MAP).findLast((label) => {
          const labelSuffix = label.energy_label.split(" ").pop();
          return labelSuffix === energyLabel;
        });
      }

      if (!energyData) {
        return null;
      }

      // Get data sheet URL from hit data
      const dataSheetUrl = hit.meta?.custom?.energylabel_datenblatt;
      const energyLabelExtendedUrl = hit.meta?.custom?.energylabel_extended;

      return {
        labelMobile: energyData.label_mobile,
        labelDesktop: energyData.label_desktop,
        energyLabel: energyData.energy_label,
        dataSheetUrl: dataSheetUrl || null,
        energyLabelExtendedUrl: energyLabelExtendedUrl || null,
      };
    } catch (error) {
      logError(error, "Failed to get energy label data");
      return null;
    }
  };

  const errorTemplate = (
    message = window.searchTranslations?.error?.default?.message,
    subtitle = window.searchTranslations?.error?.default?.subtitle,
    pageType = "default",
    hasActiveFilters = false,
  ) => {
    // Determine the appropriate messages based on page type and filter state
    let finalMessage = message;
    let finalSubtitle = subtitle;
    let buttonText = window.searchTranslations?.buttons?.resetAll || "Alle zurücksetzen";
    let buttonAction = "location.reload()";
    let showButton = true;
    if (pageType === "search") {
      if (hasActiveFilters) {
        // Search page with active filters
        finalMessage = window.searchTranslations?.error?.search?.message;
        finalSubtitle =
          window.searchTranslations?.error?.search?.subtitle;
        buttonText = window.searchTranslations?.filters?.resetAll;
        buttonAction =
          "window.__instantSearchInstance && window.__instantSearchInstance.setUiState({ shopify_at_products: { query: new URLSearchParams(window.location.search).get('q') || '' } })";
        showButton = true;
      } else {
        // Search page without filters (original behavior)
        finalMessage = window.searchTranslations?.error?.default?.message;
        finalSubtitle =
          window.searchTranslations?.error?.default?.subtitle;
        showButton = false;
      }
    } else if (pageType === "collection") {
      if (hasActiveFilters) {
        // Collection page with active filters
        finalMessage = window.searchTranslations?.error?.collection?.message;
        finalSubtitle =
          window.searchTranslations?.error?.collection?.subtitle;
        buttonText = window.searchTranslations?.filters?.resetAll;
        buttonAction =
          "window.__instantSearchInstance && window.__instantSearchInstance.setUiState({ shopify_at_products: {} })";
        showButton = true;
      } else {
        // Collection page without filters (original behavior)
        finalMessage = window.searchTranslations?.error?.collection?.message;
        finalSubtitle =
          window.searchTranslations?.error?.collection?.subtitle;
        buttonText = window.searchTranslations?.error?.collection?.buttonText;
        buttonAction = "window.location.href = '/collections'";
        showButton = true;
      }
    } else if (hasActiveFilters) {
      // Default page type with active filters
      finalMessage = window.searchTranslations?.error?.noProductsFound || "Leider keine Produkte gefunden!";
      finalSubtitle =
        window.searchTranslations?.error?.tryFewerFilters || "Verwende weniger Filter oder alle zurücksetzen";
      buttonText = window.searchTranslations?.buttons?.resetAll || "Alle zurücksetzen";
      buttonAction =
        "window.__instantSearchInstance && window.__instantSearchInstance.setUiState({ shopify_at_products: {} })";
      showButton = true;
    }

    return `
      <div class="results-empty page-width">
        <div class="results-empty-content">
          <svg aria-hidden="false" class="results-empty-notify" style="fill: none;">
            <use href="#icon-bell-notification"></use>
          </svg>
          <span class="text--body text--body-bold text--body-md text--primary">
            ${finalMessage}
          </span>
          <span class="text--body text--body-md text--primary">
            ${finalSubtitle}
          </span>
        </div>
        ${
          showButton
            ? `
          <button onclick="${buttonAction}" class="button button__secondary button__size--md results-empty-button">
            ${buttonText}
          </button>
        `
            : ""
        }
      </div>
    `;
  };

  // Update price element template in hitTemplate
  const createPriceElement = (hit, isHorizontal = false) => {
    const isOnSale = hit.compare_at_price && hit.price < hit.compare_at_price;
    const mainPriceClass = isOnSale ? 'price-element__sale' : '';
    const containerClass = isHorizontal ? 'price-element__card-horizontal' : 'price-element__card';

    return `
      <price-element tax="${TAX_RATE}">
        <div class="${containerClass}">
          <div class="price-element__card-price">
            <!-- B2B Price (Corporate) -->
            <span class="text--primary text--body text--body-md-to-lg text--extra-bold ${mainPriceClass} js-corporate-price"
                  aria-label="${window.searchTranslations?.product?.price?.currentPrice || 'Current price'}">
              ${formatPrice(hit.price)} €
            </span>
            <!-- B2C Price (Private) -->
            <span class="text--primary text--body text--body-md-to-lg text--extra-bold ${mainPriceClass} js-private-price hidden"
                  aria-label="${window.searchTranslations?.product?.price?.currentPrice || 'Current price'}">
              ${formatPrice(hit.price * TAX_RATE)} €
            </span>
            ${isOnSale ? `
              <!-- B2B Compare Price -->
              <span class="text--secondary text--body text--body-md text--strike js-corporate-price"
                    aria-label="${window.searchTranslations?.product?.price?.comparePrice || 'Compare price'}">
                ${formatPrice(hit.compare_at_price)} €
              </span>
              <!-- B2C Compare Price -->
              <span class="text--secondary text--body text--body-md text--strike js-private-price hidden"
                    aria-label="${window.searchTranslations?.product?.price?.comparePrice || 'Compare price'}">
                ${formatPrice(hit.compare_at_price * TAX_RATE)} €
              </span>
            ` : ''}
          </div>
          <!-- B2B Tax Info -->
          <span class="text--primary text--body text--body-x-sm js-corporate-price">
            ${formatPrice(hit.price * TAX_RATE)} € ${window.searchTranslations?.product?.price?.inclVat || 'inkl. MwSt.'}
          </span>
          <!-- B2C Tax Info -->
          <span class="text--primary text--body text--body-x-sm js-private-price hidden">
            ${window.searchTranslations?.product?.price?.inclVat || 'inkl. MwSt.'}
          </span>
        </div>
      </price-element>
    `;
  };

  // Update hitTemplate to use the new price element
  const hitTemplate = (hit) => {
    try {
      if (!hit || !hit.handle || !hit.title) {
        logError(new Error("Invalid hit data"), "hitTemplate");
        return "";
      }
      hitDataStore.set(hit.handle, hit);
      // Badges bauen
      const badges = [];
      if (hit.meta?.custom?.express_tag === 1 && hit.inventory_available !== false) {
        badges.push(`
            <span class="badge" style="--badge-color: var(--border-color--success);">
              ${window.searchTranslations?.badges?.express || "Express"}
            </span>
          `);
      }
      if (hit.tags?.includes("angebot")) {
        badges.push(`
            <span class="badge" style="--badge-color: var(--color--alert);">
              ${window.searchTranslations?.badges?.offer || "Angebot"}
            </span>
          `);
      }
      if (
        hit.meta?.custom?.badge &&
        BADGES_MAP[hit.meta.custom.badge.split("/").pop()] &&
        window.settings.show_custom_badge
      ) {
        badges.push(`
            <span class="badge" style="--badge-color: ${BADGES_MAP[hit.meta.custom.badge.split("/").pop()].color};">
              ${BADGES_MAP[hit.meta.custom.badge.split("/").pop()].text}
            </span>
          `);
      }
      const badgeHTML = badges.length ? `<div class="product-badges">${badges.join("")}</div>` : "";

      const imgSrc = hit.image || window.theme?.assets?.placeholder;
      const isOnSale = hit.compare_at_price && hit.price < hit.compare_at_price;

      return `
          <article class="product-card product-card--horizontal-mobile" data-product-handle="${hit.handle}" onclick="window.ProductSearch.handleProductClick('${hit.handle}', event)">
            <div class="product-card__header"
                data-collection-title="${hit.vendor || ""}"
                data-collection-id="${hit.collection_id || ""}">
              <a href="/products/${hit.handle}${hit.__queryID ? `?queryID=${hit.__queryID}` : ""}"
                class="image product-card__img"

                style="--object-fit: contain">
                <img
                  src="${imgSrc}"
                  alt="${hit.title}"
                  class="image__img image--contain"
                  loading="lazy"
                  onerror="this.src='${window.theme.assets.placeholder}'"
                />
              </a>
              ${badgeHTML}
              <div class="product-card__atc">
                ${
                  hit.inventory_available !== false
                    ? `
                <buy-button
                  data-product-handle="${hit.handle}"
                  data-variant-id="${hit.objectID}"
                  data-price="${hit.price}"
                  ${hit.__queryID ? `data-queryid="${hit.__queryID}"` : ""}
                  min-quantity="1"
                >
                  <button class="product-form__button button button__main-cta button__size--md"
                          aria-label="${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}"
                          type="button">
                    <span class="button__label" aria-hidden="true">${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}</span>
                    <svg class="button__icon" aria-hidden="true">
                      <use href="#icon-cart" fill="none"></use>
                    </svg>
                  </button>
                </buy-button>
                `
                    : ""
                }
              </div>
              <button class="product-card__like-btn wishlist"
                      data-product-handle="${hit.handle}"
                      aria-label="${window.searchTranslations?.product?.buttons?.wishlist || "In die Wunschliste"}">
                <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8 14.6668C8 14.6668 15 9.71678 15 5.03226C15 0.347746 8.78933 -0.0127883 8 4.67234C7.21067 -0.0127883 1 0.347746 1 5.3928C1 10.4379 8 14.6668 8 14.6668Z"
                    stroke="#002341"
                    stroke-width="1.25"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
            <a href="/products/${hit.handle}${hit.__queryID ? `?queryID=${hit.__queryID}` : ""}" class="product-card__body">
              <div class="product-card__info">
                <span class="text text--xx-sm text--bold text--headline-font text--none-decoration product-card__vendor">
                  ${hit.vendor || window.searchTranslations?.product?.unknownBrand || "Unknown Brand"}
                </span>
                <span class="text text--xxx-sm text--regular text--body-font text--underline-decoration product-card__title">
                  ${hit.title}
                </span>
              </div>
              ${(() => {
                const energyData = getEnergyLabelData(hit);
                if (!energyData) return "";

                return `
                  <div class="product-card__energy-label--vertical-card">
                    <button aria-label="${window.searchTranslations?.product?.energy?.openLabel || "Open energy label"}" ${energyData.energyLabelExtendedUrl ? `href="${energyData.energyLabelExtendedUrl}"` : ""} style="display:flex;height:fit-content;">
                      <div class="product-card__energy-label-image">
                        <img src="${energyData.labelMobile}" alt="${energyData.energyLabel}" width="250" height="136" loading="lazy" class="contain">
                      </div>
                    </button>
                  
                    ${
                      energyData.dataSheetUrl
                        ? `<button class="product_data-sheet" onclick="
                        event.preventDefault();
                        event.stopPropagation();
                        var downloadLink = document.createElement('a');
                        downloadLink.href = '${energyData.dataSheetUrl}';
                        downloadLink.download = '';
                        downloadLink.target = '_blank';
                        downloadLink.click();
                      ">
                        ${window.searchTranslations?.product?.buttons?.dataSheet}
                      </button>`
                        : `<base-dialog class="product-drawer__item">
                        <button class="js-dialog-opener" onclick="event.preventDefault(); event.stopPropagation();">
                          <span class="product_data-sheet">
                            ${window.searchTranslations?.product?.buttons?.dataSheet}
                          </span>
                        </button>
                        <dialog role="dialog" class="js-dialog base-dialog slide-in base-dialog--product" aria-modal="true">
                          <div class="base-dialog__content">
                            <header class="base-dialog__header">
                              <span class="text--primary text--heading text--uppercase text--headline-h5">
                                ${window.searchTranslations?.product?.buttons?.dataSheet}
                              </span>
                              <button class="base-dialog__closer js-dialog-closer" aria-label="${window.searchTranslations?.common?.close || "close"}" type="button" onclick="event.preventDefault(); event.stopPropagation();">
                                <svg width="40" height="40" aria-hidden="true" class="icon" style="--icon-fill: var(--color--secondary); --icon-stroke: var(--color--secondary);">
                                  <use xlink:href="#icon-close-drawer"></use>
                                </svg>
                              </button>
                            </header>
                            <div class="base-dialog__richtext text--default text--copy-medium-default">
                              <p>${window.searchTranslations?.product?.energy?.dataSheetUnavailable}</p>
                              <div onclick="
                                event.preventDefault();
                                event.stopPropagation();
                                var contactLink = document.createElement('a');
                                contactLink.href = '${window.searchTranslations?.product?.energy?.contactLink}';
                                contactLink.target = '_blank';
                                contactLink.click();
                              " class="button button__secondary button__size--md base-dialog__btn-margin">
                                ${window.searchTranslations?.product?.energy?.contactNow}
                              </div>
                            </div>
                          </div>
                        </dialog>
                      </base-dialog>`
                    }
                  </div>
                `;
              })()}
${
  hit.meta?.reviews?.rating && hit.meta?.reviews?.rating_count
    ? `
<div
  style="display:none; margin-top: 12px;"
  class="jdgm-prev-badge"
  data-average-rating="${JSON.parse(hit.meta.reviews.rating).value}"
  data-number-of-reviews="${hit.meta.reviews.rating_count}"
>
  <span
    class="jdgm-prev-badge__stars"
    data-score="${JSON.parse(hit.meta.reviews.rating).value}"
    tabindex="0"
    aria-label="${JSON.parse(hit.meta.reviews.rating).value} stars"
    role="button"
  >
    ${(() => {
      const rating = parseFloat(JSON.parse(hit.meta.reviews.rating).value);
      const fullStars = Math.floor(rating);
      const hasHalfStar = rating % 1 >= 0.5;
      const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

      let starsHTML = "";

      // Add full stars
      starsHTML += Array(fullStars).fill('<span class="jdgm-star jdgm--on"></span>').join("");

      // Add half star if needed
      if (hasHalfStar) {
        starsHTML += '<span class="jdgm-star jdgm--half"></span>';
      }

      // Add empty stars
      starsHTML += Array(emptyStars).fill('<span class="jdgm-star jdgm--off"></span>').join("");

      return starsHTML;
    })()}
  </span>
  <span class="jdgm-prev-badge__text"> (${hit.meta.reviews.rating_count})</span>
</div>
`
    : ""
}
              ${createPriceElement(hit)}
              <div class="product__availability ${getAvailabilityStatus(hit).className}">
                <div class="product__availability-icon" aria-hidden="true"></div>
                <span class="product__availability-text" style="${getAvailabilityStatus(hit).style}">${getAvailabilityStatus(hit).text}</span>
              </div>
            </a>
          </article>
        `;
    } catch (error) {
      logError(error, "hitTemplate rendering");
      return "";
    }
  };

  const hitTemplateList = (hit) => {
    try {
      if (!hit || !hit.handle || !hit.title) {
        logError(new Error("Invalid hit data"), "hitTemplateList");
        return "";
      }
      // Store hit data for click handling
      hitDataStore.set(hit.handle, hit);
      // Badges bauen
      const badges = [];
      if (hit.meta?.custom?.express_tag === 1 && hit.inventory_available !== false) {
        badges.push(`
            <span class="badge" style="--badge-color: var(--border-color--success);">
              ${window.searchTranslations?.badges?.express || "Express"}
            </span>
          `);
      }
      if (hit.tags?.includes("angebot")) {
        badges.push(`
            <span class="badge" style="--badge-color: var(--color--alert);">
              ${window.searchTranslations?.badges?.offer || "Angebot"}
            </span>
          `);
      }

      if (hit.meta?.custom?.badge && BADGES_MAP[hit.meta.custom.badge.split("/").pop()] && window.settings.show_custom_badge) {
        badges.push(`
            <span class="badge" style="--badge-color: ${BADGES_MAP[hit.meta.custom.badge.split("/").pop()].color};">
              ${BADGES_MAP[hit.meta.custom.badge.split("/").pop()].text}
            </span>
          `);
      }
      const badgeHTML = badges.length ? `<div class="product-badges">${badges.join("")}</div>` : "";

      const imgSrc = hit.image || window.theme?.assets?.placeholder;
      const isOnSale = hit.compare_at_price && hit.price < hit.compare_at_price;
      // Extract description bullets if available
      const descriptionHTML = hit.meta?.custom?.kurzbeschreibung_usp
        ? `
        <div class="product-card-horizontal__description">
          ${hit.meta?.custom?.kurzbeschreibung_usp}
        </div>
      `
        : "";

      return `
        <div class="products-list__item">
          <div class="product-card-horizontal" data-product-handle="${hit.handle}" onclick="window.ProductSearch.handleProductClick('${hit.handle}', event)">
            <div class="product-card-horizontal__header"
                data-collection-title="${hit.vendor || ""}"
                data-collection-id="${hit.collection_id || ""}">
              <a href="/products/${hit.handle}${hit.__queryID ? `?queryID=${hit.__queryID}` : ""}"
                      class="image product-card-horizontal__img"
                      style="--object-fit: contain"
                      product-id="${hit.objectID}">
                      <img
                        src="${imgSrc}"
                        alt="${hit.title}"
                        class="image__img image--contain"
                        loading="lazy"
                        onerror="this.src='${window.theme?.assets?.placeholder}'"
                      />
                    </a>
              <div class="product-card-horizontal__buttons">
                <button class="product-card-horizontal__like-btn wishlist"
                        data-product-handle="${hit.handle}"
                        aria-label="${window.searchTranslations?.product?.buttons?.wishlist || "In die Wunschliste"}">
                  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8 14.6668C8 14.6668 15 9.71678 15 5.03226C15 0.347746 8.78933 -0.0127883 8 4.67234C7.21067 -0.0127883 1 0.347746 1 5.3928C1 10.4379 8 14.6668 8 14.6668Z"
                      stroke="#002341"
                      stroke-width="1.25"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </button>
                <div class="product-card-horizontal__atc">
                  ${
                    hit.inventory_available !== false
                      ? `
                  <buy-button
                    data-product-handle="${hit.handle}"
                    data-variant-id="${hit.objectID}"
                    data-price="${hit.price}"
                    ${hit.__queryID ? `data-queryid="${hit.__queryID}"` : ""}
                    min-quantity="1"
                  >
                    <button class="product-form__button button button__main-cta button__size--md"
                            aria-label="${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}"
                            type="button">
                      <span class="button__label" aria-hidden="true">${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}</span>
                      <svg class="button__icon" aria-hidden="true">
                        <use href="#icon-cart" fill="none"></use>
                      </svg>
                    </button>
                  </buy-button>
                  `
                      : ""
                  }
                </div>
              </div>
            </div>
            <a href="/products/${hit.handle}${hit.__queryID ? `?queryID=${hit.__queryID}` : ""}" class="product-card-horizontal__body">
              ${badgeHTML}
              <div class="product-card-horizontal__info">
                <span class="text text--xx-sm text--bold text--headline-font text--none-decoration product-card-horizontal__vendor">
                  ${hit.vendor || window.searchTranslations?.product?.unknownBrand || "Unknown Brand"}
                </span>
                <span class="text text--x-sm text--regular text--body-font text--underline-decoration product-card-horizontal__title" style="--text-color: var(--color--secondary);">
                  ${hit.title}
                </span>
                ${
                  hit.meta?.reviews?.rating && hit.meta?.reviews?.rating_count
                    ? `
                <div
                  style="display:none"
                  class="jdgm-prev-badge"
                  data-average-rating="${JSON.parse(hit.meta.reviews.rating).value}"
                  data-number-of-reviews="${hit.meta.reviews.rating_count}"
                >
                  <span
                    class="jdgm-prev-badge__stars"
                    data-score="${JSON.parse(hit.meta.reviews.rating).value}"
                    tabindex="0"
                    aria-label="${JSON.parse(hit.meta.reviews.rating).value} stars"
                    role="button"
                  >
                    ${(() => {
                      const rating = parseFloat(JSON.parse(hit.meta.reviews.rating).value);
                      const fullStars = Math.floor(rating);
                      const hasHalfStar = rating % 1 >= 0.5;
                      const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

                      let starsHTML = "";

                      // Add full stars
                      starsHTML += Array(fullStars).fill('<span class="jdgm-star jdgm--on"></span>').join("");

                      // Add half star if needed
                      if (hasHalfStar) {
                        starsHTML += '<span class="jdgm-star jdgm--half"></span>';
                      }

                      // Add empty stars
                      starsHTML += Array(emptyStars).fill('<span class="jdgm-star jdgm--off"></span>').join("");

                      return starsHTML;
                    })()}
                  </span>
                  <span class="jdgm-prev-badge__text"> (${hit.meta.reviews.rating_count})</span>
                </div>
                `
                    : ""
                }
              </div>
              ${descriptionHTML}
            </a>
            <div class="product-card-horizontal__footer">
              ${(() => {
                const energyData = getEnergyLabelData(hit);
                if (!energyData) return "";

                return `
                  <div class="product-card__energy-label">
                    <global-fancy-box data-id="${hit.objectID}-horizontal" class="product-drawer__item" id="${hit.objectID}-horizontal">
                      <button class="js-fancy-box-opener" aria-label="${window.searchTranslations?.product?.energy?.openLabel || "Open energy label"}" data-fancybox="${hit.objectID}-horizontal" ${energyData.energyLabelExtendedUrl ? `href="${energyData.energyLabelExtendedUrl}"` : ""}>
                        <div class="product-card__energy-label-image">
                          <img src="${energyData.labelMobile}" alt="${energyData.energyLabel}" width="250" height="136" loading="lazy" class="contain">
                        </div>
                      </button>
                    </global-fancy-box>

                    ${
                      energyData.dataSheetUrl
                        ? `<a href="${energyData.dataSheetUrl}" target="_blank" class="product_data-sheet" onclick="event.preventDefault(); event.stopPropagation(); window.open('${energyData.dataSheetUrl}', '_blank');">
                        ${window.searchTranslations?.product?.buttons?.dataSheet}
                      </a>`
                        : `<base-dialog class="product-drawer__item">
                        <button class="js-dialog-opener" onclick="event.preventDefault(); event.stopPropagation();">
                          <span class="product_data-sheet">
                            ${window.searchTranslations?.product?.buttons?.dataSheet}
                          </span>
                        </button>
                        <dialog role="dialog" class="js-dialog base-dialog slide-in base-dialog--product" aria-modal="true">
                          <div class="base-dialog__content">
                            <header class="base-dialog__header">
                              <span class="text--primary text--heading text--uppercase text--headline-h5">
                                ${window.searchTranslations?.product?.buttons?.dataSheet}
                              </span>
                              <button class="base-dialog__closer js-dialog-closer" aria-label="${window.searchTranslations?.buttons?.close || "close"}" type="button" onclick="event.preventDefault(); event.stopPropagation();">
                                <svg width="40" height="40" aria-hidden="true" class="icon" style="--icon-fill: var(--color--secondary); --icon-stroke: var(--color--secondary);">
                                  <use xlink:href="#icon-close-drawer"></use>
                                </svg>
                              </button>
                            </header>
                            <div class="base-dialog__richtext text--default text--copy-medium-default">
                              <p>${window.searchTranslations?.product?.energy?.dataSheetUnavailable || "Das Produktdatenblatt ist derzeit nicht verfügbar. Bitte kontaktieren Sie uns für weitere Informationen."}</p>
                              <div onclick="
                                event.preventDefault();
                                event.stopPropagation();
                                var contactLink = document.createElement('a');
                                contactLink.href = '/pages/kontakt';
                                contactLink.target = '_blank';
                                contactLink.click();
                              " class="button button__secondary button__size--md base-dialog__btn-margin">
                                ${window.searchTranslations?.product?.energy?.contactNow || "Jetzt kontaktieren"}
                              </div>
                            </div>
                          </div>
                        </dialog>
                      </base-dialog>`
                    }
                  </div>
                `;
              })()}
              ${createPriceElement(hit, true)}
              <div class="product__availability ${getAvailabilityStatus(hit).className}">
                <div class="product__availability-icon" aria-hidden="true"></div>
                <span class="product__availability-text" style="${getAvailabilityStatus(hit).style}">${getAvailabilityStatus(hit).text}</span>
              </div>
              <buy-button
                class="product-card-horizontal__footer-atc"
                data-product-handle="${hit.handle}"
                data-variant-id="${hit.objectID}"
                data-price="${hit.price}"
                ${hit.__queryID ? `data-queryid="${hit.__queryID}"` : ""}
                min-quantity="1"
              >
                ${
                  hit.inventory_available !== false
                    ? `
                <button class="product-form__button button button__main-cta button__size--md"
                        aria-label="${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}"
                        type="button">
                  <span class="button__label" aria-hidden="true">${window.searchTranslations?.product?.buttons?.add_to_cart || "In den Warenkorb"}</span>
                  <svg class="button__icon" aria-hidden="true">
                    <use href="#icon-cart" fill="none"></use>
                  </svg>
                </button>
                `
                    : ""
                }
              </buy-button>
            </div>
          </div>
        </div>
        `;
    } catch (error) {
      logError(error, "hitTemplateList rendering");
      return "";
    }
  };
  // Clear hit data store when results are updated
  const clearHitDataStore = () => {
    hitDataStore.clear();
  };
  Object.assign(ns, { errorTemplate, hitTemplate, hitTemplateList, initializeBadgesMap, getEnergyLabelData , handleProductClick, clearHitDataStore});
})((window.ProductSearch = window.ProductSearch || {}));
